import { render, staticRenderFns } from "./developmentStaff.vue?vue&type=template&id=4d157e11&scoped=true"
import script from "./developmentStaff.vue?vue&type=script&lang=js"
export * from "./developmentStaff.vue?vue&type=script&lang=js"
import style0 from "./developmentStaff.vue?vue&type=style&index=0&id=4d157e11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d157e11",
  null
  
)

export default component.exports